import { FunctionComponent, useRef } from 'react'
import { Button } from 'antd'
import { XIcon } from '@mercadoni/gungnir'

export type QuotasFleet = {
  id?: string
  label?: string
  color?: string
}

export type QuotasLocation = {
  top: number
  left: number
}

export type QuotasConfirmActionProps = {
  buttonText?: string
  addQuotaText?: string
  fleets?: QuotasFleet[]
  selectedOption?: string
  onCleanOption?: () => void
  onSelectedOption?: (option?: string) => void
  location: QuotasLocation
  visible?: boolean
  className?: string
}

const QUOTAS_WIDTH = 592
const QUOTAS_HEIGHT = 614

export const QuotasConfirmAction: FunctionComponent<QuotasConfirmActionProps> = ({
  buttonText = 'Liberar cupo',
  addQuotaText = 'Agregar cupo a',
  fleets = [
    {
      label: 'Flota 1',
      id: '1',
      color: '#1890FF'
    },
    {
      label: 'Flota 2',
      id: '2',
      color: '#DE1870'
    }
  ],
  selectedOption = '',
  onCleanOption = () => {},
  onSelectedOption = () => {},
  location = {
    top: 0,
    left: 0
  },
  visible = false,
  className = ''
}: QuotasConfirmActionProps): JSX.Element => {
  const ref = useRef(null)

  const getItemsList = () => {
    return (
      <div className='gungnir-qca-fleet-list'>
        {fleets.map(({ label, id, color }, idx) => {
          return (
            <div
              className={`gungnir-qca-fleet ${selectedOption === id ? 'selected' : ''}`}
              onClick={() => onSelectedOption(id)}
              style={color ? { borderLeft: `4px solid ${color}` } : {}}
              key={idx}
              id={id}
            >
              <span>{label}</span>
            </div>
          )
        })}
      </div>
    )
  }

  const getLeftValue = () => {
    const currentRef = ref ? ref.current || { offsetWidth: 0 } : { offsetWidth: 0 }
    const confirmWidth = currentRef.offsetWidth
    if (location.left + confirmWidth <= QUOTAS_WIDTH) {
      return location.left
    }
    return location.left - confirmWidth
  }

  const getTopValue = () => {
    const currentRef = ref ? ref.current || { offsetHeight: 0 } : { offsetHeight: 0 }
    const confirmHeight = currentRef.offsetHeight
    if (location.top + confirmHeight <= QUOTAS_HEIGHT) {
      return location.top
    }
    return location.top - confirmHeight
  }

  return visible ? (
    <div
      ref={ref}
      data-testid='gungnir-qca'
      className={`gungnir-qca ${className}`}
      style={{ top: getTopValue(), left: getLeftValue() }}
    >
      <Button onClick={onCleanOption} icon={<XIcon />} className='gungnir-qca-button' type='link'>
        {buttonText}
      </Button>
      <div className='gungnir-qca-division' />
      <div className='gungnir-qca-title'>{addQuotaText}:</div>
      {getItemsList()}
    </div>
  ) : (
    <div />
  )
}
